import { tracking } from '@podiumhq/tracking';
import TRACKING_EVENTS from './trackingEvents';
import { AMPLITUDE_TOKEN } from '../env';

export default function setupTracking() {
  tracking.init({
    enabled: true,
    events: TRACKING_EVENTS,
    debug: true,
    amplitudeToken: AMPLITUDE_TOKEN,
  });
}
